import * as React from 'react';

import styles from './uppercase-label.module.css';

type Props = {
    children?: React.ReactNode;
    as: string;
};

UppercaseLabel.defaultProps = {
    as: 'label',
};

/*
 * This component is responsible for rendering a 12px all uppercased
 * label that we use on the new lead pages.
 */
export function UppercaseLabel({children, as: Tag}: Props) {
    // @ts-expect-error
    return <Tag className={styles['uppercase-label']}>{children}</Tag>;
}
